import React from 'react'
import ReactDOM from 'react-dom'
import Root from './Root'
import registerServiceWorker from './registerServiceWorker'
import 'bulma/css/bulma.css'
import 'bulma.overwrite.css'

ReactDOM.render(<Root />, document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js